const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNdiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1047 550",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58203,0,0,1.58203,-304.591,-159.901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.414,136.141L204.414,413.32L272.481,413.32L272.481,296.207C272.481,288.865 276.896,283.725 283.887,283.725C289.774,283.725 293.821,287.029 300.444,297.309L373.663,413.32L447.985,413.32L447.985,136.141L379.918,136.141L379.918,254.722C379.918,262.065 375.502,267.204 368.512,267.204C362.625,267.204 358.577,263.9 351.955,253.621L278.736,136.141L204.414,136.141Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58203,0,0,1.58203,-304.591,-159.901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.403,274.547C717.403,198.185 653.015,136.141 574.277,136.141L464.633,136.141L464.633,413.32L574.277,413.32C653.383,413.32 717.403,350.909 717.403,274.547ZM647.496,274.18C647.496,318.602 614.75,350.909 569.862,350.909L541.596,350.909C536.683,350.909 532.701,346.935 532.701,342.034L532.701,207.427C532.701,202.526 536.683,198.552 541.596,198.552L569.862,198.552C614.75,198.552 647.496,230.859 647.496,274.18Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58203,0,0,1.58203,-304.591,-159.901)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 732.173,
    y: 136.141,
    width: 68.068,
    height: 277.179,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.58203,0,0,1.58203,-304.591,-159.901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M828.241,386.195C820.366,386.195 814.241,392.145 814.241,399.729C814.241,407.37 820.366,413.32 828.241,413.32C836.116,413.32 842.241,407.37 842.241,399.729C842.241,392.145 836.116,386.195 828.241,386.195ZM828.241,388.47C834.657,388.47 839.674,393.37 839.674,399.729C839.674,406.087 834.657,411.045 828.241,411.045C821.824,411.045 816.807,406.087 816.807,399.729C816.807,393.37 821.824,388.47 828.241,388.47ZM833.899,396.812C833.899,394.304 831.799,392.495 828.882,392.495L823.632,392.495L823.632,407.02L826.257,407.02L826.257,401.129L830.924,407.02L833.957,407.02L830.282,402.47C830.049,402.179 829.932,401.829 829.932,401.537C829.932,401.07 830.166,400.72 830.691,400.604L830.749,400.604C832.674,400.137 833.899,398.679 833.899,396.812ZM831.157,396.929C831.157,398.212 830.224,398.97 828.766,398.97L826.257,398.97L826.257,394.829L828.766,394.829C830.224,394.829 831.157,395.645 831.157,396.929Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdiLogo);
export default __webpack_public_path__ + "static/media/ndi_logo.846c61187d2608f0a7d7300619507306.svg";
export { ForwardRef as ReactComponent };